<div class="amp-dialog">
  <div class="amp-dialog-header">
    <div class="amp-dialog-title">
      {{ title }}
    </div>
    <div class="amp-dialog-subtitle">{{ subtitle }}</div>
    <div class="loader"></div>
  </div>
</div>